import { useEffect } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { useNavigate } from "react-router-dom";
import { isAndroidApp, mobileAuthReturnUrl } from "@/lib/nativePlatform";

export const AppLinkListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAndroidApp() || !mobileAuthReturnUrl) return undefined;
    const allowedHost = new URL(mobileAuthReturnUrl).hostname;
    let handle;
    CapacitorApp.addListener("appUrlOpen", async ({ url }) => {
      const incoming = new URL(url);
      if (incoming.hostname !== allowedHost) return;
      await Browser.close().catch(() => undefined);
      navigate(`${incoming.pathname}${incoming.search}${incoming.hash}`, { replace: true });
    }).then((listener) => { handle = listener; });
    return () => { handle?.remove(); };
  }, [navigate]);

  return null;
};